import styled from "@emotion/native"
import { ReactNode, useState } from "react"
import { Spacing, Text } from "../ui-components"
import PlusIcon from "../assets/onboarding-v2/plus.svg"

type AccordionProps = {
  header: string
  children: ReactNode
  openByDefault?: boolean
}

export function Accordion({ header, children, openByDefault = false }: AccordionProps) {
  const [isExpanded, setExpanded] = useState(openByDefault)

  return (
    <Wrapper>
      <UpperPart onPress={() => setExpanded(!isExpanded)}>
        <UpperTextContainer>
          <Text fontSize={26} lineHeight={31} fontFamily="IBMPlexSans-SemiBold">
            {header}
          </Text>
        </UpperTextContainer>
        <PlusIcon />
      </UpperPart>
      {isExpanded ? (
        <>
          <Spacing top={20} />
          {children}
        </>
      ) : (
        <Line />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.View``

const UpperTextContainer = styled.View`
  max-width: 80%;
`

const UpperPart = styled.Pressable`
  flex-direction: row;
  justify-content: space-between;
`

const Line = styled.View`
  background-color: ${({ theme }) => theme.v2.components.accordion.lineColor};
  height: 2px;
  width: 100%;
  margin-top: 24px;
`
